import {Action} from "redux";

export const ToggleDrawerSizeActionName = 'ToggleDrawerSizeAction';

export interface ToggleDrawerSizeAction extends Action {
}

export const toggleDrawerSizeActionBuilder = (): ToggleDrawerSizeAction => ({
    type: ToggleDrawerSizeActionName
});